import { render, staticRenderFns } from "./ImportantNotice.vue?vue&type=template&id=40f6754f&scoped=true"
import script from "./ImportantNotice.vue?vue&type=script&lang=js"
export * from "./ImportantNotice.vue?vue&type=script&lang=js"
import style0 from "./ImportantNotice.vue?vue&type=style&index=0&id=40f6754f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f6754f",
  null
  
)

export default component.exports